import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ForecastManagerService } from 'src/services/forecast-services/forecast-manager.service';

@Component({
  selector: 'forecast-data-manager-renderer',
  template: `<a  class="product-title-link" (click)="btnEditClickHandler()">{{params.value}}</a>`,
})
export class ForecastDataManagerEditRenderComponent implements ICellRendererAngularComp, OnDestroy {
  params: any;

  constructor(private forecastManagerService: ForecastManagerService,) {
  }

  agInit(params: any): void {
    this.params = params;
  }

  btnEditClickHandler() {
    this.forecastManagerService.forecastGridActionDataCellSubject.next({ forecastData: this.params.data });
  }

  refresh(params?: any): boolean {
    return true;
  }

  ngOnDestroy() {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
